import React, { useEffect, useState } from 'react';
import './Gallery.css';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import Languages from './Languages';
import GALLERY1 from '../images/1.jpg';
import GALLERY2 from '../images/2.jpeg';
import GALLERY3 from '../images/3.jpg';
import GALLERY4 from '../images/4.jpg';
import GALLERY5 from '../images/5.jpeg';
import GALLERY6 from '../images/6.jpg';
import GALLERY7 from '../images/7.jpg';
import GALLERY8 from '../images/8.jpg';
import GALLERY9 from '../images/9.jpg';
import GALLERY10 from '../images/10.jpg';
import GALLERY11 from '../images/11.jpg';
import GALLERY12 from '../images/12.jpg';
import GALLERY13 from '../images/13.jpg';
import GALLERY14 from '../images/14.jpg';
import GALLERY15 from '../images/15.jpg';
import GALLERY16 from '../images/16.jpg';
import GALLERY17 from '../images/17.jpg';
import GALLERY18 from '../images/18.jpeg';
import GALLERY19 from '../images/19.mp4';
import GALLERY20 from '../images/20.jpeg';

import Reviews from './Reviews';

import WORLDMAPJPG from '../images/WORLDMAPJPG.jpg'; // Adjust path as necessary
import Galleryhero from './Galleryhero';

export default function Gallery() {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);

  // State to manage open/close state of each FAQ item
  const [openFaq, setOpenFaq] = useState(null);

  // Toggle FAQ item
  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index); // Close if already open, otherwise open
  };
  return (
    <div>
      
    <div><Navbar /></div>
    <div>

      <Galleryhero/>
      {/* <section id="hero"  >
        <div className="hero-content">
          <h1>SHIVA NADI ASTROLOGY</h1>
          <p>Ancient Wisdom | Future Insights</p>
          <center>
            <p id="langu">Telugu | Hindi | Malayalam | Tamil | English</p>
            </center>
          <a href="tel:+917402167580" className="hero-btn">Get Appointment?</a>
        </div>
      </section> */}

      <section id="About">
        <div className='container'>
          <div className='row'>
            <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
              <h2>Explore the Divine Insights</h2>
              <p>
Step into the world of Shiva Nadi Astrology, where ancient wisdom meets modern curiosity.
Discover the sacred palm leaf manuscripts that unveil your life's destiny.
Our gallery showcases authentic artifacts, spiritual practices, and life-changing readings.
Journey through the mystical interpretations inspired by Lord Shiva's divine guidance.
Each image tells a story of enlightenment, hope, and timeless knowledge.
Witness the devotion and expertise of our astrologers, preserving this ancient legacy.
Experience the profound connection between your soul and the universe through Nadi Astrology..</p>
            </div>
          </div>
        </div>
      </section>



      <section id="PSRL">

<div className='container'>
<div className='row'>
<div className='col-lg-12 col-md-12 col-sm-12 col-12'>


<h2>32+ YEARS Experiences</h2>


</div>

</div>

</div>
</section>
<section id="PSRL">

<div className='container'>
<div className='row'>
<div className='col-lg-12 col-md-12 col-sm-12 col-12'>

<img src={WORLDMAPJPG} alt="Gallery Image 1" className="img-fluid rounded" /> 


</div>
<h5>We Offer Our Service All Over The World</h5>
</div>

</div>
</section>

<section id="gallery-section">
  <div class="container">
    <div class="row">
      <div class="col-lg-3 col-md-4 col-sm-6 col-12 gallery-item">
        <img src={GALLERY1} alt="Gallery Image 1" class="gallery-img" />
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-12 gallery-item">
        <img src={GALLERY2} alt="Gallery Image 2" class="gallery-img" />
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-12 gallery-item">
        <img src={GALLERY3} alt="Gallery Image 3" class="gallery-img" />
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-12 gallery-item">
        <img src={GALLERY4} alt="Gallery Image 4" class="gallery-img" />
      </div>
      {/* <div class="col-lg-3 col-md-4 col-sm-6 col-12 gallery-item">
        <img src={GALLERY5} alt="Gallery Image 5" class="gallery-img" />
      </div> */}
      <div class="col-lg-3 col-md-4 col-sm-6 col-12 gallery-item">
        <img src={GALLERY6} alt="Gallery Image 6" class="gallery-img" />
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-12 gallery-item">
        <img src={GALLERY7} alt="Gallery Image 7" class="gallery-img" />
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-12 gallery-item">
        <img src={GALLERY8} alt="Gallery Image 8" class="gallery-img" />
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-12 gallery-item">
        <img src={GALLERY9} alt="Gallery Image 9" class="gallery-img" />
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-12 gallery-item">
        <img src={GALLERY10} alt="Gallery Image 10" class="gallery-img" />
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-12 gallery-item">
        <img src={GALLERY11} alt="Gallery Image 11" class="gallery-img" />
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-12 gallery-item">
        <img src={GALLERY12} alt="Gallery Image 12" class="gallery-img" />
      </div>
      {/* <div class="col-lg-3 col-md-4 col-sm-6 col-12 gallery-item">
        <img src={GALLERY12} alt="Gallery Image 12" class="gallery-img" />
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-12 gallery-item">
        <img src={GALLERY13} alt="Gallery Image 12" class="gallery-img" />
      </div> */}
      <div class="col-lg-3 col-md-4 col-sm-6 col-12 gallery-item">
        <img src={GALLERY14} alt="Gallery Image 12" class="gallery-img" />
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-12 gallery-item">
        <img src={GALLERY15} alt="Gallery Image 12" class="gallery-img" />
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-12 gallery-item">
        <img src={GALLERY16} alt="Gallery Image 12" class="gallery-img" />
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-12 gallery-item">
        <img src={GALLERY17} alt="Gallery Image 12" class="gallery-img" />
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-12 gallery-item">
        <img src={GALLERY18} alt="Gallery Image 12" class="gallery-img" />
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-12 gallery-item">
        <video src={GALLERY19} alt="Gallery Image 12" class="gallery-img" />
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-12 gallery-item">
        <img src={GALLERY20} alt="Gallery Image 12" class="gallery-img" />
      </div>
    </div>
  </div>
</section>






<section id="why-choose-us">
  <div class="container">
    <h2>Why Choose Us?</h2>
    <div class="features">
      <div class="feature-box">
        <i class="icon fas fa-trophy"></i>
        <h3>Proven Expertise</h3>
        <p>Over a decade of experience delivering top-notch services to clients.</p>
      </div>
      <div class="feature-box">
        <i class="icon fas fa-user-check"></i>
        <h3>Customer Satisfaction</h3>
        <p>Our clients are our priority, and we go the extra mile to meet their needs.</p>
      </div>
      <div class="feature-box">
        <i class="icon fas fa-chart-line"></i>
        <h3>Results-Driven</h3>
        <p>We focus on achieving measurable outcomes for your success.</p>
      </div>
      <div class="feature-box">
        <i class="icon fas fa-headset"></i>
        <h3>24/7 Support</h3>
        <p>Our team is available around the clock to assist with any concerns.</p>
      </div>
    </div>
  </div>
</section>




<div><Reviews/></div>
    {/* Other sections */}
<section id="faq-insurance">
  <div className="container">
    <h2>FAQs - Frequently Asked Questions</h2>
    <div className="accordion">
      {[
        { 
          question: "How can Apollo Agency assist with house insurance?", 
          answer: "We provide expert guidance to help you choose the best house insurance policy, ensuring your property is adequately protected." 
        },
        { 
          question: "What services do you offer for life insurance?", 
          answer: "We offer a range of life insurance options tailored to your financial goals and family security, ensuring peace of mind for your loved ones." 
        },
        { 
          question: "Do you provide health insurance plans?", 
          answer: "Yes, we offer personalized health insurance plans that cover medical expenses and provide financial protection during health emergencies." 
        },
        { 
          question: "Can Apollo Agency help with bike insurance?", 
          answer: "Absolutely! We assist with selecting comprehensive and third-party bike insurance plans that suit your needs and budget." 
        },
        { 
          question: "Do you provide car insurance services?", 
          answer: "Yes, we offer car insurance options that include comprehensive coverage, third-party liability, and add-on benefits to ensure complete protection for your vehicle." 
        },
        { 
          question: "Why should I choose Apollo Agency for insurance?", 
          answer: "Our expertise, transparency, and partnerships with leading insurers ensure you get the best coverage at competitive rates." 
        },
        { 
          question: "Do you offer any discounts on insurance policies?", 
          answer: "Yes, we provide seasonal discounts, referral bonuses, and exclusive deals to make your insurance purchase more affordable." 
        },
      ].map((faq, index) => (
        <div className="accordion-item" key={index}>
          <div className="accordion-header" onClick={() => toggleFaq(index)}>
            <h3>{faq.question}</h3>
            <i className={`icon fas fa-chevron-${openFaq === index ? "up" : "down"}`}></i>
          </div>
          <div className={`accordion-content ${openFaq === index ? "open" : ""}`}>
            <p>{faq.answer}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>
 
<section id="contact-info">
  <h2>Contact Us</h2>
  <div class="contact-container">
    <div class="contact-item">
      <i class="fas fa-map-marker-alt"></i>
      <h3>Office Address</h3>
      <p>LIG- B, Plot No: 204, Dr. AS Rao Nagar Rd, beside SUB POST OFFICE, Anupuram Colony, A. S. Rao Nagar, Hyderabad, Secunderabad, Telangana 500062</p>
    </div>
    <div class="contact-item">
      <i class="fas fa-phone-alt"></i>
      <h3>Contact</h3>
      <p>Phone: +91 74021 67580<br/>Email:shivanadiastrologer@gmail.com</p>
    </div>
    <div class="contact-item">
      <i class="fas fa-map"></i>
      <h3>Map</h3>
      <p>
      <a href="https://www.google.com/maps?q=LIG-+B,+Plot+No:+204,+Dr.+AS+Rao+Nagar+Rd,+beside+SUB+POST+OFFICE,+Anupuram+Colony,+A.+S.+Rao+Nagar,+Hyderabad,+Secunderabad,+Telangana+500062" target="_blank">View on Google Maps</a>

      </p>
    </div>
  </div>
</section>


      <section id="opening-hours">
  <h2>Opening Hours</h2>
  <table class="hours-table">
    <thead>
      <tr>
        <th>Day</th>
        <th>Time</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          <i class="fas fa-calendar-day"></i> Monday to Saturday
        </td>
        <td>
          <i class="fas fa-clock"></i> 10 AM - 7 PM
          <br/>
          <i class="fas fa-utensils"></i> Lunch: 2 PM - 3 PM
        </td>
      </tr>
      <tr>
        <td>
          <i class="fas fa-calendar-day"></i> Sunday
        </td>
        <td>
          <i class="fas fa-times-circle"></i> Closed
        </td>
      </tr>
    </tbody>
  </table>
</section>


    <div><Footer /></div>
  </div>
  </div>
  )
}
